import Checkbox from '../checkbox/Checkbox';
import FilterContainer from './FilterContainer';
import { useFilterContext } from './hooks';
import { CheckboxFilterConfig } from './types';

type CheckboxFilterProps = {
    title: string;
    id: string;
};

function CheckboxFilter({ title, id }: CheckboxFilterProps): JSX.Element {
    const filterInstance = useFilterContext();
    const filter = filterInstance.getFilterSection<CheckboxFilterConfig>(id);

    return (
        <FilterContainer
            title={title}
            isOpen={filterInstance.getActiveFilterCount(id) > 0}
            activeFilterCount={filterInstance.getActiveFilterCount(id)}
        >
            <ul className="p-2">
                {filter?.options?.map((option, idx) => {
                    return (
                        <li key={idx} className="text-sm mt-2 first:mt-0 flex gap-2 items-center">
                            <Checkbox
                                checked={option.active}
                                onChange={(e): void => {
                                    filterInstance.updateCheckboxOption(id, option.value, e.target.checked);
                                    // filterInstance.toggleCheckbox(title, option.id, e.target.checked);
                                }}
                                label={option.label}
                            />
                        </li>
                    );
                })}
            </ul>
        </FilterContainer>
    );
}

export default CheckboxFilter;
